<template>
  <fs-tooltip
    v-if="disabled"
    :text="typeof disabled === 'string' ? disabled : 'Can not be deleted'"
    show-even-if-not-ellipsed
  >
    <icon-button
      :size="size"
      :icon="trashCanIcon"
      :color="color"
      :text="text"
      disabled
      :icon-scale="iconScale"
      :icon-vertical-shift="iconVerticalShift"
    />
  </fs-tooltip>
  <icon-button
    v-else
    :size="size"
    :icon="trashCanIcon"
    :color="color"
    :text="text"
    :icon-scale="iconScale"
    :icon-vertical-shift="iconVerticalShift"
    @click="openModal"
  >
    <confirm-deletion-modal
      ref="confirmModal"
      :item-name="itemName"
      :item-type-name="itemTypeName"
      :fetch-usage-count="fetchUsageCount"
      :block-when-used="blockWhenUsed"
      :blocked-by="blockedBy"
      :delete-callback="deleteCallback"
      :additional-warning="additionalWarning"
      :confirm-text="confirmText"
      @confirm="onConfirm"
      @cancel="onCancel"
      @deleted="onDeleted"
      @closed="onClosed"
    >
      <template v-for="(_, slotName) in slots" v-slot:[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps ?? {}" />
      </template>
    </confirm-deletion-modal>
  </icon-button>
</template>

<script setup lang="ts" generic="TUsage extends number | any[] | Record<string, any>">
import { useTemplateRef } from 'vue';
import IconButton from '@components/icon-button.vue';
import FsTooltip from '@components/poppers/fs-tooltip.vue';
import ConfirmDeletionModal from '@components/modals/confirm-deletion-modal.vue';
import trashCanIcon from '@icons/other/trash-can-icon.svg';

const { color = 'red' } = defineProps<{
  // Modal content
  itemName?: string;
  itemTypeName?: string;
  fetchUsageCount?: () => Promise<TUsage>;
  /** Refuse the deletion while anything still references the item. See confirm-deletion-modal. */
  blockWhenUsed?: boolean;
  /** Refuse the deletion while this holds for the loaded usages. See confirm-deletion-modal. */
  blockedBy?: (usage: TUsage) => boolean;
  deleteCallback?: () => Promise<void>;
  additionalWarning?: string;
  confirmText?: string;

  // Button styling
  size?: 'nano' | 'tiny' | 'small' | 'medium' | 'large';
  color?: string;
  text?: string;
  disabled?: boolean | string;
  iconScale?: number;
  iconVerticalShift?: number;
}>();

const slots = defineSlots();

const emit = defineEmits<{
  confirm: [];
  cancel: [];
  deleted: [];
  closed: [];
}>();

const confirmModal = useTemplateRef('confirmModal');

function openModal() {
  confirmModal.value?.open();
}

function onConfirm() {
  emit('confirm');
}

function onCancel() {
  emit('cancel');
}

function onDeleted() {
  emit('deleted');
}

function onClosed() {
  emit('closed');
}
</script>
